import DeviceRegistrationSecondForm from "../../../forms/DeviceRegistrationForms/Registration/DeviceRegistrationSecondForm";
import "../DeviceBaseRegistration.css"

const DeviceRegistrationSecond = () => {
    return (
        <>
            <DeviceRegistrationSecondForm/>
        </>
    )
}

export default DeviceRegistrationSecond;
